module.exports = __webpack_public_path__ + "static/img/qrxq.6b173b37.png";